/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

class AppLocalStorage
{
  signature = '1.1.0';                          // Remember to change this...!!!
  keyStub = null;
  gatewayNameLS = 'userPreferences.gatewayName';
  autoPlayLS = 'userPreferences.autoPlay';
  apiUserId = undefined;

  clear()
  {
    let signatureKey = this.apiUserId + '.objVault.localStorage.signature';
    let keys = [];
    for (let x = 0; x < localStorage.length; x++)
    {
      if (this.keyStub === localStorage.key(x).substring(0, this.keyStub.length) &&
          signatureKey !== localStorage.key(x))
        keys.push(localStorage.key(x));
    }

    for (let x = 0; x < keys.length; x++) localStorage.removeItem(keys[x]);

    localStorage.setItem(signatureKey, this.signature);
  }

  constructor(apiUserId)
  {
    this.apiUserId = apiUserId;

    let signatureKey = apiUserId + '.objVault.localStorage.signature';
    this.keyStub = apiUserId + '.objVault.';

    if (undefined === localStorage[signatureKey])
    {
      let keys = [];
      let keyStub = 'objVault';
      for (let x = 0; x < localStorage.length; x++)
      {
        if (keyStub === localStorage.key(x).substring(0, keyStub.length))
          keys.push(localStorage.key(x));
      }
  
      for (let x = 0; x < keys.length; x++) localStorage.removeItem(keys[x]);

      localStorage.setItem(signatureKey, this.signature);
    }

    if (this.signature !== localStorage[signatureKey]) this.clear();
  }

  getAutoPlay()
  {
    let lValue = localStorage.getItem(this.keyStub + this.autoPlayLS);
    return null === lValue ? 'N' : lValue;
  }
  
  getColumnWidths(columns, key)
  {
    let columnWidths = JSON.parse(this.getItem(key));
    if (columnWidths === null || 'null' === columnWidths)
      return {};
    else
    {
      for (let i = 0; i < columns.length; i++)
      {
        var columnName;
        for (columnName in columnWidths)
        {
          if (columnWidths.hasOwnProperty(columnName) && columns[i].id === columnName)
          {
            columns[i].width = columnWidths[columnName];
            break;
          }
        }
      }
    }
  
    return columnWidths;
  }    

  getGatewayName()
  {
    let lValue = localStorage.getItem(this.keyStub + this.gatewayNameLS);
    return (null === lValue ? '' : lValue);
  }

  getItem(key)
  {
    return localStorage.getItem(this.keyStub + key);
  }

  saveColumnWidths(resizedColumns, columnWidths, key)
  {
    for (let i = 0; i < resizedColumns.length; i++)
    {
      columnWidths[resizedColumns[i].id] = resizedColumns[i].value;
    }
    this.setItem(key, JSON.stringify(columnWidths));
  }

  setAutoPlay(value)
  {
    let lVal = 'null' === value ? null : value;
    localStorage.setItem(this.keyStub + this.autoPlayLS, lVal);
  }

  setGatewayName(value)
  {
    let lVal = ('null' === value ? null : value);
    localStorage.setItem(this.keyStub + this.gatewayNameLS, lVal);
  }

  setItem(key, value)
  {
    localStorage.setItem(this.keyStub + key, value);
  }
}

export default AppLocalStorage